export var NotificationType;
(function (NotificationType) {
    // Communication
    NotificationType["CHAT_MESSAGE"] = "chat_message";
    // Job Operations
    NotificationType["JOB_CREATED"] = "job_created";
    NotificationType["JOB_UPDATED"] = "job_updated";
    NotificationType["JOB_DELETED"] = "job_deleted";
    NotificationType["JOB_IMPORT_COMPLETED"] = "job_import_completed";
    NotificationType["JOB_OPTIMIZATION_COMPLETED"] = "job_optimization_completed";
    // Candidate Operations
    NotificationType["CANDIDATE_CREATED"] = "candidate_created";
    NotificationType["CANDIDATE_UPDATED"] = "candidate_updated";
    /** Bulk variant: many candidates updated atomically (consent grant,
     *  bulk tag/state changes). Carries the full new state of each affected
     *  candidate. Mirrors the SCHEDULED_MESSAGES_UPDATED bulk pattern. */
    NotificationType["CANDIDATES_UPDATED"] = "candidates_updated";
    NotificationType["CANDIDATE_DELETED"] = "candidate_deleted";
    NotificationType["CANDIDATE_BATCH_COMPLETED"] = "candidate_batch_completed";
    NotificationType["CANDIDATE_PROCESSING_ERROR"] = "candidate_processing_error";
    // Calendar
    NotificationType["INTERVIEW_SCHEDULED"] = "interview_scheduled";
    // Anti-ghosting follow-up sequence
    NotificationType["SCHEDULED_MESSAGE_UPDATED"] = "scheduled_message_updated";
    /** Bulk variant: many messages updated atomically (cancel-all, skip-all,
     *  config-replan). Carries the full new state of each affected message. */
    NotificationType["SCHEDULED_MESSAGES_UPDATED"] = "scheduled_messages_updated";
    /** Admin hard-delete — the doc no longer exists. Subscribers should drop
     *  the row from their cache. */
    NotificationType["SCHEDULED_MESSAGE_DELETED"] = "scheduled_message_deleted";
    // Organization
    NotificationType["ORG_UPDATED"] = "org_updated";
    /** The communication report's counters grew (common/commEvents.ts): the amounts a rollup added. */
    NotificationType["COMM_METRICS_UPDATED"] = "comm_metrics_updated";
    // User profile (per-user channel: activePreview, profile changes, etc.)
    NotificationType["USER_UPDATED"] = "user_updated";
    // Scoring Progress
    NotificationType["SCORING_RETRY"] = "scoring_retry";
    // General
    NotificationType["SYSTEM_ALERT"] = "system_alert";
})(NotificationType || (NotificationType = {}));
